<div class="flex p-3 mb-5 bg-gray-50">
    <div class="flex-1 lg:flex-[0_0_50%] border-l-4 border-gray-700 pl-4">
        <div class="flex flex-col">
            <p class="text-xs uppercase text-gray-500 font-medium tracking-wide">
                Manage Account Section
            </p>
            <h2 class="text-xl font-bold whitespace-nowrap text-gray-700 leading-tight">
                 {{subSection}}
            </h2>
        </div>
    </div>
</div>